/*
 *   File : rebalance-history.js
 *   Author : https://evoqins.com
 *   Description : rebalance history component
 *   Integrations : NA
 *   Version : 1.0.0
 */
import React, { useEffect } from "react";
import { DataTableComponent } from "../../../Components/DataTable";

const DATA = [
  {
    id: 1,
    date: "25 Nov 2025",
    name: "Nippon India Large Cap Fund",
    changes:
      "Added fund: Nippon India Large Cap Fund, allocation 10%.",
  },
  {
    id: 2,
    date: "23 Nov 2025",
    name: "Bandhan Infrastructure Growth Fund",
    changes:
      "Changed allocation: Bandhan Infrastructure Growth Fund from 30% to 10%.",
  },
  {
    id: 3,
    date: "20 Nov 2025",
    name: "ICICI Prudential Bluechip Fund",
    changes:
      "Added SIP: ₹2,000/month. Updated allocation from 15% to 20%.",
  },
  {
    id: 4,
    date: "18 Nov 2025",
    name: "HDFC Midcap Opportunities Fund",
    changes:
      "Reduced allocation: HDFC Midcap Opportunities Fund from 25% to 18%.",
  },
  {
    id: 5,
    date: "15 Nov 2025",
    name: "Kotak Flexicap Fund",
    changes:
      "Switched units worth ₹12,000 to Kotak Flexicap Fund. Allocation increased from 8% to 12%.",
  },
  {
    id: 6,
    date: "12 Nov 2025",
    name: "Axis Small Cap Fund",
    changes:
      "Changed SIP: from ₹1,500 to ₹2,500/month. Allocation adjusted from 10% to 14%.",
  },
];


export default function RebalanceHistory({ setFilterData, setFilterType }) {
  useEffect(() => {
    setFilterData({});
    setFilterType(null);
  }, []);

  const COLUMNS = [
    {
      name: "Date",
      selector: (row) => row.date,
  
      width: "160px"
    },
    {
      name: "Name Of Investment",
      selector: (row) => row.name,
  
      wrap: true,
      width: "300px"
    },
    {
      name: "Changes",
      selector: (row) => row.changes,
      sortable: false,
      wrap: true,
      width: "350px",
    },
  ];

  return (
    <div className="pt-1 row-gap-3 d-flex rounded-16 flex-column">
      {/* PAGINATED TABLE */}
      <DataTableComponent
        info={false}
        columns={COLUMNS}
        data={DATA}
        className="e-table-basic"
      />
    </div>
  );
}
